import { SxProps } from '@mui/material';

export const backgroundColorStyles = (color: string): SxProps => ({
  backgroundColor: color,
});
